import React from 'react';
import styled from 'styled-components';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {connect} from 'react-redux';
import SeatsScreen from './SeatsScreen';
import './SeatsSelection.css';

const ZoomBox = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const RowWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

const Auditorium = styled.div`
    border-top: none;
    margin-top: 1em;
    max-width: 100%;
    padding: 4rem 2rem 1rem;
    position:relative;
    
    ${props => props.screenImage
      ? `
        background: none;
        padding-top: 8rem;
        `
      : `
        background-image:-webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(0,0,0,0.25)), color-stop(15%, rgba(255,255,255,0)));
        background-image:linear-gradient(to bottom, rgba(0,0,0,0.25) 0, rgba(255,255,255,0) 15%);
        border-radius: 30% 30% 0 0 / 10% 10% 0 0
        &:before {
            border-radius: 30% 30% 0 0 / 10% 10% 0 0
            border-top: 5px solid rgba(208,3,61,0.5);
            content: "";
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 0;
        }
        `}
`;

class SeatsSelectionAuditoriumWithZoom extends React.Component {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef(null);
    this.contentRef = React.createRef(null);
    this.onResize = this.onResize.bind(this);
    this.transformUtils = null;

    this.ref = React.createRef();

    this.state = {
      zoomData: {
        minScale: 0.5,
        maxScale: 1.5
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.setSeatTransformUtils();
  }

  setSeatTransformUtils() {
    // Wait a tick to ensure the DOM is fully rendered
    setTimeout(() => {
      if (this.wrapperRef.current && this.contentRef.current && this.transformUtils) {
        const wrapperWidth = this.wrapperRef.current.offsetWidth;
        const contentWidth = this.contentRef.current.offsetWidth;
        const proportionalWidth = wrapperWidth / contentWidth;
        const initialScale = proportionalWidth < 1 ? proportionalWidth : 1;

        const zoomData = {
          ...this.state.zoomData,
          minScale: initialScale
        }

        this.transformUtils.setTransform(0, 10, initialScale);
        this.setState({ zoomData });
      }
    }, 0);
  }

  render() {
    return (
      <ZoomBox innerRef={this.wrapperRef}>
        <TransformWrapper
          minScale={this.state.zoomData.minScale}
          maxScale={this.state.zoomData.maxScale}
          wheel={{ wheelDisabled: true }}
          pinch={{ step: 0.3 }}
          doubleClick={{ disabled: true }}
          limitToBounds={false}
          centerOnInit={true}
          onInit={(utils) => {
            this.transformUtils = utils;
          }}
        >
          <TransformComponent wrapperClass="mx-auto">
            <div ref={this.contentRef} className="c-seats">
              <Auditorium className="c-seats__container" screenImage={this.props.screenImage !== null}>
                <SeatsScreen />
                <RowWrapper>
                  <div innerRef={this.ref}>
                    {this.props.children}
                  </div>
                </RowWrapper>
              </Auditorium>
            </div>
          </TransformComponent>
        </TransformWrapper>
      </ZoomBox>
    );
  }
}


const mapStateToProps = state => ({
  screenImage: state.checkoutData.data.screen_override || null,
});

export default connect(
  mapStateToProps
)(SeatsSelectionAuditoriumWithZoom);